import { fetchUtils } from 'react-admin'
import { updateSessionExpirationTime } from '../helpers/authUtils';
import { appendIndustryIdToUrl, INDUSTRY_SCOPED_RESOURCES } from '../utils/industryUtils';

export const apiUrl = ''
export const TABLES_PATH = '/tables';

export const httpClient = (url, options = {}) => {
   if (!options.headers) {
      options.headers = new Headers({Accept: 'application/json'})
   }

    const urlObj = new URL(url, window.location.origin); // Normalize the URL
    // DELETE carries no body, so industry_id passed in query string
    if (options.method === 'DELETE' &&
        INDUSTRY_SCOPED_RESOURCES.some(resource => urlObj.pathname.startsWith(`${TABLES_PATH}/${resource}/`))) {
        url = appendIndustryIdToUrl(url);
    }

   return fetchUtils.fetchJson(url, options)
   .then(response => {
      const sessionExpiryTime = response.headers.get('X-Session-Expiry-Time');
      if (sessionExpiryTime) {
         updateSessionExpirationTime(sessionExpiryTime);
      }
      return response;
   })
   .catch(err => {
      if (err.status === 401) {
         localStorage.removeItem('isLogin')
         localStorage.removeItem('user')
         localStorage.removeItem('filter')
         document.location.reload()
         return
      }

      if (err.status === 403) {
         window.location.replace('/not-allowed')
         return
      }

      return err
   })
}




